import { render, staticRenderFns } from "./Visualizacao.vue?vue&type=template&id=78667487&"
import script from "./Visualizacao.vue?vue&type=script&lang=js&"
export * from "./Visualizacao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports